interface Coordinates {
  latitude: number;
  longitude: number;
}

const EARTH_RADIUS_METRES = 6371000;
const toRadians = (degrees: number) => (degrees * Math.PI) / 180;

/**
 * Great-circle distance in metres.
 *
 * Used to compare the coordinates Choco stored against the ones Google returns
 * for the same place today: a large gap means the place moved, was repointed, or
 * the stored pair never matched the address in the first place.
 */
export const distanceBetween = (a: Coordinates, b: Coordinates): number => {
  const deltaLatitude = toRadians(b.latitude - a.latitude);
  const deltaLongitude = toRadians(b.longitude - a.longitude);
  const halfChordSquared =
    Math.sin(deltaLatitude / 2) ** 2 +
    Math.cos(toRadians(a.latitude)) *
      Math.cos(toRadians(b.latitude)) *
      Math.sin(deltaLongitude / 2) ** 2;

  return Math.round(
    2 *
      EARTH_RADIUS_METRES *
      Math.atan2(Math.sqrt(halfChordSquared), Math.sqrt(1 - halfChordSquared))
  );
};

/** Beyond this, stored and live coordinates describe different places. */
export const COORDINATE_DRIFT_THRESHOLD_METRES = 100;
